import { render } from "./view.vue?vue&type=template&id=34705f5c&ts=true"
import script from "./view.vue?vue&type=script&lang=ts"
export * from "./view.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Matches/view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34705f5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34705f5c', __exports__)) {
    api.reload('34705f5c', __exports__)
  }
  
  module.hot.accept("./view.vue?vue&type=template&id=34705f5c&ts=true", () => {
    api.rerender('34705f5c', render)
  })

}


export default __exports__